import type { VoidComponent } from "solid-js";

// Always use Dutch locale no matter what the user has configured
export const DEFAULT_DATE_TIME_FORMAT = new Intl.DateTimeFormat("nl-NL", {
  dateStyle: "short",
  timeStyle: "short",
});

// Always use Dutch locale no matter what the user has configured
export const DEFAULT_DATE_FORMAT = new Intl.DateTimeFormat("nl-NL", {
  dateStyle: "short",
});

export const DEFAULT_TIME_FORMAT = new Intl.DateTimeFormat("nl-NL", {
  timeStyle: "short",
});

export const formatDate = (value: Date, dateOnly = false) =>
  (dateOnly ? DEFAULT_DATE_FORMAT : DEFAULT_DATE_TIME_FORMAT).format(value);

const FormatDate: VoidComponent<{
  value: Date;
  dateOnly?: boolean;
}> = (props) => <>{formatDate(props.value, props.dateOnly)}</>;

export default FormatDate;
